import { AfterViewInit, Component, NgZone, OnDestroy, OnInit} from "@angular/core";
import { AtlasClickResultComponent } from "../atlas-click-result.component";
import { Feature } from "ol";
import { Geometry } from "ol/geom.js";
import { HttpClient } from "@angular/common/http";
import { BootstrapMediaService } from "src/app/services/bootstrap-media.service";
import { TranslationHelperService } from "src/app/services/translations/translation-helper.service";
import * as GeoJSONModule from "ol/format/GeoJSON.js";
const GeoJSON = GeoJSONModule.default as typeof GeoJSONModule.default;
import { OLMapService } from 'src/app/services/ol-map/ol-map.service';
import { AtlasFtthFilterService } from 'src/app/services/filter/atlas-ftth-filter.service';
import { catchError, defer, finalize, forkJoin, map, of, switchMap, tap, timeout } from 'rxjs';
import { unsubscribe } from 'src/app/utils/helpers';

@Component({
  standalone: false,
  selector: "app-atlas-ftth-map",
  templateUrl: "./atlas-ftth-map.component.html",
  styleUrls: ["./atlas-ftth-map.component.scss"] })
export class AtlasFtthMapComponent extends AtlasClickResultComponent implements OnInit, AfterViewInit, OnDestroy {
  private latestClickRequestId = 0;

  constructor(
    protected http: HttpClient,
    protected breakpointObserver: BootstrapMediaService,
    protected translationHelper: TranslationHelperService,
    private atlasFtthFilterService: AtlasFtthFilterService,
    public olMapService: OLMapService,
    private readonly zone: NgZone
  ) {
    super(http, breakpointObserver, translationHelper, olMapService);
  }
  ngOnInit(): void {

    this.atlasFtthFilterService.setQueryParams();
    this.atlasFtthFilterService.atlasFtthService.setDefaultFilter();



    this.mapOperations();
    this.checkDataCurrentQuarter();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.atlasFtthFilterService.atlasFtthService.getLegends("ftth-legend");
      this.atlasFtthFilterService.atlasFtthService.getFilter("ftth-filter");
      this.atlasFtthFilterService.atlasFtthService.getDetails("ftth-detail");
    });
  }

  mapOperations(): void {
    this.subscriptions.push(this.olMapService.mapClick$.pipe(
      map((event) => ({ event, requestId: ++this.latestClickRequestId })),
      tap(() => this.zone.run(() => {
        this.atlasFtthFilterService.atlasFtthService.removeVectorLayers();
        this.olMapService.details = [];
        this.olMapService.detailsLoading = true;
        this.olMapService.notifyDetailStateChanged();
      })),
      switchMap(({ event, requestId }) => defer(() => {
        const requests = this.atlasFtthFilterService.atlasFtthService.mapOperations(event);
        if (!requests?.length) {
          return of({ requestId, featureCollections: [] });
        }

        return forkJoin(requests).pipe(
          map((featureCollections) => ({ requestId, featureCollections }))
        );
      }).pipe(
        timeout(15000),
        catchError(() => of({ requestId, featureCollections: [] })),
        finalize(() => this.zone.run(() => {
          if (requestId === this.latestClickRequestId) {
            this.olMapService.detailsLoading = false;
            this.olMapService.notifyDetailStateChanged();
          }
        }))
      ))
    ).subscribe((result) => {
      if (result.requestId !== this.latestClickRequestId) {
        return;
      }

      this.zone.run(() => {
        this.renderMultipleResponses(
          result.featureCollections,
          () => this.atlasFtthFilterService.atlasFtthService.removeVectorLayers(),
          (features) => {
            const format = new GeoJSON();
            this.updateDetails(features[0]);
            this.addVectorLayer(features[0], format);
          }
        );
        this.olMapService.notifyDetailStateChanged();
      });
    }));
  }  getLayerDetails(feature: Feature<Geometry>) {
    this.atlasFtthFilterService.atlasFtthService.getLayerDetails(feature);
  }
  getLayerName(): string[] {
    return this.atlasFtthFilterService.atlasFtthService.getLayerName();
  }
  getStyleName(): string {
    return this.atlasFtthFilterService.atlasFtthService.getStyleName();
  }
  loadLayer() {
    this.atlasFtthFilterService.atlasFtthService.loadLayer();
  }
  setFilter(layerPostfix: string) {
    this.atlasFtthFilterService.atlasFtthService.setFilter(layerPostfix);
  }
  updateDetails(feature: Feature<Geometry>) {
    this.atlasFtthFilterService.atlasFtthService.updateDetails(feature);
  }
  checkDataCurrentQuarter(): void {
    this.atlasFtthFilterService.atlasFtthService.checkDataCurrentQuarter();
  }
  getPreviousQuarterPostfix(currentQuarter: string): string {
    return this.atlasFtthFilterService.atlasFtthService.getPreviousQuarterPostfix(currentQuarter);
  }
  addVectorLayer(feature: Feature<Geometry>, format: any) {
    this.atlasFtthFilterService.atlasFtthService.addVectorLayer(feature, format);
  }
  ngOnDestroy(): void {
    this.atlasFtthFilterService.atlasFtthService.mapOperationsUn();
    unsubscribe(this.subscriptions)
  }
}




